import script from "./PluginPricing.vue?vue&type=script&setup=true&lang=js"
export * from "./PluginPricing.vue?vue&type=script&setup=true&lang=js"

import "./PluginPricing.vue?vue&type=style&index=0&id=2f905938&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f905938"]])

export default __exports__